import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import axios from "axios";
import CKEditor from "ckeditor4-vue";
import { installCKEditor } from "@/helpers/ckeditor";
import InstantSearch from "vue-instantsearch";
import capitalizeFirst from './filters/capitalizeFirst';
import featureFlags from './plugins/featureFlags';
import "./mixins/dateFormat";
import TableFooter from '@/components/TableFooter.vue';


Vue.use(InstantSearch);
Vue.prototype.$ALGOLIA_APP_ID = process.env.VUE_APP_ALGOLIA_APP_ID;
Vue.prototype.$ALGOLIA_APP_TOKEN = process.env.VUE_APP_ALGOLIA_APP_TOKEN;
Vue.prototype.$QUESTION_INDEX = process.env.VUE_APP_QUESTION_INDEX;
Vue.prototype.$USERS_INDEX = process.env.VUE_APP_USERS_INDEX;
Vue.prototype.$FRONTEND_DOMAIN = process.env.VUE_APP_FRONTEND_DOMAIN;
Vue.prototype.$DEEPLINK = process.env.VUE_APP_DEEPLINK;
Vue.prototype.$PACKAGE_NAME = process.env.VUE_APP_PACKAGE_NAME;

// Pins the editor URL and registers the WIRIS plugin at the right moment.
// See src/helpers/ckeditor.js - CKEditor is no longer loaded from index.html.
installCKEditor(Vue, CKEditor);
Vue.use(featureFlags);
Vue.component('TableFooter', TableFooter);
Vue.config.productionTip = false;
axios.defaults.withCredentials = false;
// axios.defaults.baseURL = 'https://lmsbackend.knoggles.ai/api/v1/';

Vue.filter('capitalizeFirst', capitalizeFirst);

// Kick the feature-flag fetch off as soon as this module is evaluated rather than
// from the root instance's created hook, so the request is already in flight while
// Vue boots. init() swallows its own errors and leaves the flags empty, and the
// flags are exposed through a Vue.observable, so components that read them before
// the response lands simply re-render when it arrives.
Vue.prototype.$featureFlags.init();

new Vue({
  vuetify,
  store,
  router,
  created() {
    this.$store.watch(
      (state) => state.chartSearch,
      (newValue, oldValue) => {
        console.log("chartSearch changed:", newValue);
        // Perform any desired actions with the new value
      }
    );
  },
  render: (h) => h(App),
}).$mount("#app");
